module.exports = __webpack_public_path__ + "img/visi.a61fecbd.svg";